module.exports = __webpack_public_path__ + "static/img/qrcode.ad6d30c3.png";